'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('selfAccessRequestControllers')

    .controller('AdHocController', ['$scope', '$modal', '$state', '$stateParams', '$translate', 'topBar', 'selfAccessRequestService', 'selfAccessRequest', 'processStepsByStepName',
 function ($scope, $modal, $state, $stateParams, $translate, topBar, selfAccessRequestService, selfAccessRequest, processStepsByStepName) {

     var totalStepsCompletedOrSkipped = 0;

     $scope.selfAccessRequest = selfAccessRequest;
     onActiveStepChange(selfAccessRequest.ProcessStepStatusList);

     $scope.newIamUrl = environment.iamUrl;

     // Skip Step
     $scope.skipStep = function ($event, step) {

         selfAccessRequestService
             .skipProcessStepForSelfAccessRequest($stateParams.userAccessRequestId, step)
             .then(function (selfAccessRequest) {
                onActiveStepChange(selfAccessRequest.ProcessStepStatusList);
             });
     }

     // Go To RemoveRights
     $scope.goToRemoveRights = function () {

         var processStep = _.find($scope.processStepStatusList, {
             Step: 'RemoveRights'
         });

         // InProgress/Completed - Go to Decisions
         if (processStep.IsInProgress || processStep.IsCompleted) {
             $state.go('selfAccessRequest.adHoc.removeRights', {}, { reload: true });
             return;
         }

         // Skipped - Do nothing
         if (processStep.IsSkipped) return;

         $scope.isLoadingRemoveRights = true;

         selfAccessRequestService
             .createRemoveRightsDecisions($stateParams.userAccessRequestId)
             .then(function (removeRightsDecisions) {
                 $scope.isLoadingRemoveRights = false;

                 if (_.isUndefined(removeRightsDecisions.NoDataReason)) {
                     $state.go('selfAccessRequest.adHoc.removeRights');
                     return;
                 }

                 var modalScope = $scope.$new(true);
                 modalScope.NoDataReason = removeRightsDecisions.NoDataReason;
                 var noDecisionsModal = $modal({
                     scope: modalScope,
                     template: require('./removeRights/NoDecisionsModal.tpl.html'),
                     placement: 'center'
                 });

                 modalScope.hideModal = function () {
                     noDecisionsModal.$promise.then(noDecisionsModal.hide);
                 };

                 modalScope.okModal = function () {
                     modalScope.hideModal();
                 };

                 modalScope.skipRemoveRightsStep = function () {
                     selfAccessRequestService.skipProcessStepForSelfAccessRequest($stateParams.userAccessRequestId, 'RemoveRights')
                      .then(function (selfAccessRequest) {
                          modalScope.hideModal();
                          $state.go(selfAccessRequest.SelfRequestPageRoute, {}, {
                              reload: true
                          });
                      });

                 }

             });
     }

     // Go To PreAuthorized
     $scope.goToPreAuthorized = function () {

         var processStep = _.find($scope.processStepStatusList, {
             Step: 'PreAuthorized'
         });

         // InProgress/Completed - Go to Decisions
         if (processStep.IsInProgress || processStep.IsCompleted) {
             $state.go('selfAccessRequest.adHoc.preAuthorized', {}, { reload: true });
             return;
         }

         if (processStep.IsSkipped) return;

         selfAccessRequestService
            .createPreAuthorizedDecisions($stateParams.userAccessRequestId)
            .then(function (preAuthorizedDecisions) {
                  if (!_.isUndefined(preAuthorizedDecisions.NoDataReason)) {
                      var modalScope = $scope.$new(true);
                      modalScope.NoDataReason = preAuthorizedDecisions.NoDataReason;
                      var noDecisionsModal = $modal({
                          scope: modalScope,
                          template: require('./preAuthorized/NoDecisionsModal.tpl.html'),
                          placement: 'center'
                      });

                      modalScope.hideModal = function () {
                          noDecisionsModal.$promise.then(noDecisionsModal.hide);
                      };

                      modalScope.okModal = function () {
                          modalScope.hideModal();
                      };

                      modalScope.skipPreAuthorizedStep = function (event) {
                          $scope.skipStep(event, 'PreAuthorized');
                          modalScope.hideModal();
                      }
                      return;
                  }

                $state.go('selfAccessRequest.adHoc.preAuthorized', {}, { reload: true });

              });
     }

     // Go To Same As
     $scope.goToSameAs = function () {

         var processStep = _.find($scope.processStepStatusList, {
             Step: 'SameAs'
         });

         // InProgress/Completed - Go to Decisions
         if (processStep.IsInProgress || processStep.IsCompleted) {
             $state.go('selfAccessRequest.adHoc.sameAs', {}, { reload: true });
             return;
         }

         // Skipped - Do nothing
         if (processStep.IsSkipped) return;

         var modalScope = $scope.$new(true);
         var chooserNewSameAsModal = $modal({
             scope: modalScope,
             template: require('../../../shared/components/controllers/selfAccessRequest/SelectSameAsModal.tpl.html'),
             placement: 'center'
         });
         modalScope.hideModal = function () {
             chooserNewSameAsModal.$promise.then(chooserNewSameAsModal.hide);
         }
         modalScope.okModal = function () {
             modalScope.hideModal();
         }
         modalScope.skipStep = function (event) {
             $scope.skipStep(event, 'SameAs');
             modalScope.hideModal();
         }

         // Add the selected employee
         modalScope.newSameAsEmployee = function (selectedEmployee) {
             modalScope.isLoadingSameAsEmployee = true;

             return selfAccessRequestService
                        .selectSameAsEmployee($stateParams.userAccessRequestId,
                                              selectedEmployee.EmployeeID)
                        .then(function (decisionContainer) {
                            modalScope.isLoadingSameAsEmployee = false;

                            if (decisionContainer.NoDataReason) return decisionContainer;

                            modalScope.hideModal();
                            $state.go('selfAccessRequest.adHoc.sameAs', {
                                sameAsEmployeeID: selectedEmployee.EmployeeID
                            }, {
                                reload: true
                            });

                            return decisionContainer;
                        });
         }
     }

     // Go to Other Catalog Permissions
     $scope.goToOtherCatalogPermissions = function () {

         var processStep = _.find($scope.processStepStatusList, {
             Step: 'OtherCatalogPermissions'
         });

         // Skipped
         if (processStep.IsSkipped) return;

         // IsPendingCompletion/Completed - Go to Decisions
         if (processStep.IsPendingCompletion || processStep.IsCompleted) {
             $state.go('selfAccessRequest.adHoc.otherCatalog', {}, { reload: true });
             return;
         }
     }

     // Go To Special Needs
     $scope.goToSpecialNeeds = function () {

         var processStep = _.find($scope.processStepStatusList, {
             Step: 'SpecialNeeds'
         });

         if (!(processStep.IsActive || processStep.IsSkipped)) {
             return;
         }

         $state.go('selfAccessRequest.adHoc.otherNeeds', {}, { reload: true });
     }

     // Go to AdHoc Confirmation Page
     $scope.goToNeedValidation = function () {

         var processStep = _.find($scope.processStepStatusList, {
             Step: 'NeedValidation'
         });

         if (processStep.IsSkipped) {
             $state.go('selfAccessRequest.adHoc.validation', {}, { reload: true });
         }

         if (!processStep.IsActive) return;

         selfAccessRequestService
              .confirmProcessStepForSelfAccessRequest($stateParams.userAccessRequestId, 'NeedValidation')
              .then(function (request) {
                  $state.go(request.SelfRequestPageRoute, {}, { reload: true });
              });
     }

     // Go To Next Action
     $scope.goToNextAction = function () {
         if (_.isUndefined($scope.activeProcessStep)) return;

         if ($scope.activeProcessStep.Step === "RemoveRights") {
             $scope.goToRemoveRights();
             return;
         }

         if ($scope.activeProcessStep.Step === "PreAuthorized") {
             $scope.goToPreAuthorized();
             return;
         }

         if ($scope.activeProcessStep.Step === "SameAs") {
             $scope.goToSameAs();
             return;
         }

         if ($scope.activeProcessStep.Step === "OtherCatalogPermissions") {
             $scope.goToOtherCatalogPermissions();
             return;
         }

         if ($scope.activeProcessStep.Step === "SpecialNeeds") {
             $scope.goToSpecialNeeds();
             return;
         }

         if ($scope.activeProcessStep.Step === "NeedValidation") {
             $scope.goToNeedValidation();
             return;
         }
     }

     // Reset Ownership
     $scope.deleteOwnership = function () {
         selfAccessRequestService
             .deleteAdHocSelfAccessRequest($stateParams.userAccessRequestId)
             .then(function (response) {
                 window.location = $scope.newIamUrl;
              });
     }

     // Helpers
     function onActiveStepChange(processStepStatusList) {

         $scope.processStepStatusList = processStepStatusList;

         $scope.activeProcessStep = _.find(processStepStatusList, {
             IsPendingCompletion: true
         });

         if (!_.isUndefined($scope.activeProcessStep)) {
             // Load translation asynchronously to avoid race condition
             $translate('iam.selfAccessRequest.adHoc.pageTitle').then(function(translation) {
                 topBar.setTitleAndIcon(translation + ' &nbsp;<i class="fa fa-chevron-right fa-align"></i>&nbsp; ' +
                                       '<i class="' + $scope.activeProcessStep.CssIcon + '"></i> ' + $scope.activeProcessStep.StepTitleEN, 'fa-shopping-cart');
             });
         }

         $scope.stepsDone = _.countBy(processStepStatusList, {
             IsDone: true
         }).true;
     }
 }
]);
